import { withTranslation } from "react-i18next";
import CodeEditor from './CodeEditor'
import './CodeEditor.less'
export default withTranslation()(CodeEditor);